<h1>Sites</h1>
<p>
  Select sites and set desired/available releases. Setting the desired release pushes it to IoT Hub for all edge devices
  connected to the selected sites. Available releases define what the on-prem UI can offer.
</p>
<p>
  The toggle filters filter sites on the state property. This property should reflect the delivery state of the site.
  Such that pending means planned to be installed. And prod means that system is installed and in use.
</p>
<button mat-raised-button color="primary" [disabled]="selected.selected.length == 0" (click)="openBulkDesiredDialog()">
  Set Desired ({{ selected.selected.length }})
</button>
<button
  mat-raised-button
  color="primary"
  style="margin-left: 8px"
  [disabled]="selected.selected.length == 0"
  (click)="openBulkAvailableReleasesDialog()"
>
  Set Latest Available ({{ selected.selected.length }})
</button>
<br />
<br />
<div class="search-form">
  <mat-form-field appearance="fill" style="width: 250px">
    <mat-label>Search</mat-label>
    <input
      matInput
      type="string"
      placeholder="Search for name, customer, state"
      [(ngModel)]="filters.searchString"
      (input)="filterSites()"
    />
  </mat-form-field>
  <mat-form-field appearance="fill" style="width: 180px">
    <mat-label>Customer</mat-label>
    <mat-select [(ngModel)]="filters.customer" (selectionChange)="filterSites()">
      <mat-option value="">All</mat-option>
      <mat-option *ngFor="let c of uniqueCustomers" [value]="c">{{ c }}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="fill" style="width: 180px">
    <mat-label>Current Release</mat-label>
    <mat-select [(ngModel)]="filters.currentRelease" (selectionChange)="filterSites()">
      <mat-option value="">All</mat-option>
      <mat-option *ngFor="let v of uniqueReleaseVersions" [value]="v">{{ v }}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="fill" style="width: 180px">
    <mat-label>Desired Release</mat-label>
    <mat-select [(ngModel)]="filters.desiredRelease" (selectionChange)="filterSites()">
      <mat-option value="">All</mat-option>
      <mat-option *ngFor="let v of uniqueReleaseVersions" [value]="v">{{ v }}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="fill" style="width: 180px">
    <mat-label>Deploy Health</mat-label>
    <mat-select [(ngModel)]="filters.deploymentStatus" (selectionChange)="filterSites()">
      <mat-option value="">All</mat-option>
      <mat-option value="1">Healthy</mat-option>
      <mat-option value="2">Reporting Failure</mat-option>
      <mat-option value="3">Container Mismatch</mat-option>
      <mat-option value="0">Unknown</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-slide-toggle [(ngModel)]="filters.prod" (change)="filterSites()"> Prod </mat-slide-toggle>
  <mat-slide-toggle [(ngModel)]="filters.pending" (change)="filterSites()"> Pending </mat-slide-toggle>
  <mat-slide-toggle [(ngModel)]="filters.dev" (change)="filterSites()"> Dev </mat-slide-toggle>
  <mat-slide-toggle [(ngModel)]="filters.discontinued" (change)="filterSites()"> Discontinued </mat-slide-toggle>
  <mat-slide-toggle [(ngModel)]="filters.demo" (change)="filterSites()"> Demo </mat-slide-toggle>
</div>
<br />
<p>Showing {{ sitesTableSource.data.length }} of {{ sites ? sites.length : 'null' }} sites:</p>
<div
  *ngIf="sites; let sites; else: loading"
  style="max-height: 75vh; overflow-y: scroll; width: 100%; max-width: fit-content"
>
  <table
    mat-table
    [dataSource]="sitesTableSource"
    matSort
    (matSortChange)="onSortChange($event)"
    class="mat-elevation-z8"
    style="width: 100%"
    aria-label="Filtered table of all sites"
  >
    <ng-container matColumnDef="select">
      <th *matHeaderCellDef>
        <mat-checkbox
          (change)="$event ? masterToggle() : null"
          [checked]="selected.hasValue() && isAllSelected()"
          [indeterminate]="selected.hasValue() && !isAllSelected()"
          class="w-64"
        >
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let element" class="w-64">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selected.toggle(element) : null"
          [checked]="selected.isSelected(element)"
        >
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="id">Id</th>
      <td mat-cell *matCellDef="let element">
        <a
          mat-stroked-button
          raised
          [routerLink]="['/customer/' + element.customer.id + '/site/' + element.id + '/details']"
          >{{ element.id }}</a
        >
      </td>
    </ng-container>
    <ng-container matColumnDef="customer">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="customer">Customer</th>
      <td mat-cell *matCellDef="let element">{{ element.customer.name }}</td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Name</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>
    <ng-container matColumnDef="state">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="state">State</th>
      <td mat-cell *matCellDef="let element">{{ element.state }}</td>
    </ng-container>
    <ng-container matColumnDef="deploymentStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="deploymentStatus">IoT Reported</th>
      <td mat-cell *matCellDef="let element">
        <span class="deploy-badge" [ngClass]="getDeploymentStatusClass(element)">
          {{ getDeploymentStatusLabel(element) }}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="onPremStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="onPremStatus">On-Prem Reported</th>
      <td mat-cell *matCellDef="let element">
        <span class="deploy-badge" [ngClass]="getOnPremStatusClass(element)">
          {{ getOnPremStatusLabel(element) }}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="currentRelease">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="currentRelease">Current</th>
      <td mat-cell *matCellDef="let element">
        <span [class.on-latest]="isOnLatest(element)">{{ getCurrentVersion(element) }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="desiredRelease">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="desiredRelease">Desired</th>
      <td mat-cell *matCellDef="let element">{{ getDesiredVersion(element) }}</td>
    </ng-container>
    <ng-container matColumnDef="latestAvailable">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="latestAvailable">Latest Available</th>
      <td mat-cell *matCellDef="let element">
        {{ getLatestAvailableVersion(element) }}
        <mat-icon
          *ngIf="isLatestAvailableReady(element) !== null"
          class="ready-icon"
          [class.ready-icon-ready]="isLatestAvailableReady(element) === true"
          [class.ready-icon-pending]="isLatestAvailableReady(element) === false"
          [matTooltip]="isLatestAvailableReady(element) ? 'Ready to install' : 'Not yet downloaded'"
          >download</mat-icon
        >
      </td>
    </ng-container>
    <ng-container matColumnDef="isAutoUpdate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="isAutoUpdate">Update mode</th>
      <td mat-cell *matCellDef="let element">{{ isAutoUpdateEnabled(element) ? 'Auto' : 'Manual' }}</td>
    </ng-container>
    <ng-container matColumnDef="connectPOB">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="connectPOB">ConnectPOB</th>
      <td mat-cell *matCellDef="let element">{{ element.featureFlags?.connectPOB }}</td>
    </ng-container>
    <ng-container matColumnDef="gangway">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="gangway">Gangway</th>
      <td mat-cell *matCellDef="let element">{{ element.featureFlags?.gangway }}</td>
    </ng-container>
    <ng-container matColumnDef="connectFuel">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="connectFuel">ConnectFuel</th>
      <td mat-cell *matCellDef="let element">{{ element.featureFlags?.connectFuel }}</td>
    </ng-container>
    <ng-container matColumnDef="cargoConditionMonitoring">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="cargoConditionMonitoring">CargoConditionMonitoring</th>
      <td mat-cell *matCellDef="let element">{{ element.featureFlags?.cargoConditionMonitoring }}</td>
    </ng-container>
    <ng-container matColumnDef="cabinBunkManagement">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="cabinBunkManagement">CabinBunkManagement</th>
      <td mat-cell *matCellDef="let element">{{ element.featureFlags?.cabinBunkManagement }}</td>
    </ng-container>
    <ng-container matColumnDef="hvac">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="hvac">HVAC</th>
      <td mat-cell *matCellDef="let element">{{ element.featureFlags?.hvac }}</td>
    </ng-container>
    <ng-container matColumnDef="comment">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="comment">Comment</th>
      <td mat-cell *matCellDef="let element">{{ element.comment }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <!-- TODO: Link to details page for Site -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<ng-template #nullTemplate>Null</ng-template>

<ng-template #loading>
  <div class="loading-indicator">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
  </div>
</ng-template>
